export const QUERY_KEYS = {
  IMAGE_CATEGORIES: 'image_categories',
  USER: 'user',
  PATCH_USER: 'patch_user',
  PATCH_ADMIN_USER: 'patch_admin_user',
  FAMILIES: 'families',
  FAMILY_TAGS: 'family_tags',
  FAMILY_TAGS_CATEGORIES: 'family_tags_categories',
  POST_TAG: 'family_post_tag',
  FAMILY_COMMUNITIES: 'family_communities',
  FAMILY_SEARCHED_COMMUNITY_REFERRALS: 'family_searched_community_referrals',
  FAMILY_SEARCHED_COMMUNITIES: 'family_searched_communities',
  PATCH_FAMILY: 'patch_family',
  SINGLE_FAMILY: 'single_family',
  DUPLICATE_FAMILIES: 'duplicate_families',
  CONVERSATION: 'conversation',
  CONVERSATIONS: 'conversations',
  FAMILY_CONVERSATION: 'family_conversation',
  MESSAGE: 'message',
  MESSAGES: 'messages',
  NOTES: 'notes',
  SINGLE_NOTE: 'single_note',
  POST_NOTE: 'post_note',
  PATCH_NOTE: 'patch_note',
  TASKS: 'tasks',
  POST_TASK: 'post_task',
  PATCH_TASK: 'patch_task',
  POST_COMMUNITY_TASK: 'post_community_task',
  PATCH_COMMUNITY_TASK: 'patch_community_task',
  UPCOMING_TASK: 'upcoming_task',
  USER_TASKS: 'user_tasks',
  TASKS_META: 'tasks_meta',
  PLATFORM_USERS: 'platform_users',
  UUIDAUXES: 'uuidAuxes',
  PATCH_UUIDAUXES: 'patch_uuidAuxes',
  SEARCH_AGENTS: 'search_agents',
  SEARCH_REAL_ESTATE_AGENTS: 'search_real_estate_agents',
  GET_AGENTS: 'get_agents',
  SINGLE_AGENT: 'single_agent',
  SINGLE_REAL_ESTATE_AGENT: 'single_real_estate_agent',
  AGENT_BASIC_INFO: 'agent_basic_info',
  AGENT_COUNTY_NAMES_INFO: 'agent_county_names_info',
  PATCH_AGENT: 'patch_agent',
  PATCH_REAL_ESTATE_AGENT: 'patch_real_estate_agent',
  DELETE_AGENT_IMAGE: 'delete_agent_image',
  DELETE_REAL_ESTATE_AGENT_IMAGE: 'delete_real_estate_agent_image',
  NOTIFICATIONS: 'notifications',
  API_NOTIFICATIONS: 'api_notifications',
  AGENTS: 'agents',
  REAL_ESTATE_AGENTS: 'real_estate_agents',
  CONTACTS: 'contacts',
  SINGLE_CONTACT: 'single_contact',
  PATCH_CONTACT: 'patch_contact',
  GET_CONTACT: 'get_contact',
  REVIEWS: 'reviews',
  SINGLE_REVIEW: 'single_review',
  PATCH_REVIEW: 'patch_review',
  USERS: 'users',
  ORGANIZATION: 'organization',
  STATS: 'stats',
  ADMIN_USERS: 'admin_users',
  SINGLE_COMMUNITY: 'single_community',
  COMMUNITIES: 'communities',
  PATCH_COMMUNITY: 'patch_community',
  PATCH_COMMUNITY_IMAGES: 'patch_community_images',
  PATCH_COMMUNITY_PRICES: 'patch_community_prices',
  ADD_COMMUNITY_IMAGE: 'add_community_image',
  ORGANIZATIONS: 'organizations',
  PATCH_ORGANIZATION: 'patch_organization',
  COMMUNITY_REVIEWS: 'community_reviews',
  AGENT_REVIEWS: 'agent_reviews',
  POST_AGENT_NOTE: 'post_agent_note',
  AGENT_NOTES: 'agent_notes',
  PATCH_AGENT_NOTE: 'patch_agent_note',
  PATCH_MESSAGE_PARTICIPANT: 'patch_message_participant',
  ADD_COMMUNITY_VIDEO: 'add_community_video',
  PATCH_COMMUNITY_VIDEO: 'patch_community_video',
  CLIENT_COMMUNITY_MESSAGE: 'client_community_message',
  GET_D2C_INTEGRATIONS: 'get_d2c_integrations',
  FAMILY_DATATABLE: 'family_data_table',
  CLIENT_REFERRALS: 'client_referrals',
  TASKS_DATATABLE: 'tasks_datatable',
  CLIENT_REFERRALS_DATATABLE: 'client_referrals_datatable',
  PARTNER_COLLECTIONS: 'partner_collections',
  PATCH_PARTNER_COLLECTION: 'patch_partner_collection',
  SINGLE_PARTNER_COLLECTION: 'single_partner_collection',
  CREATE_PARTNER_COLLECTION: 'create_partner_collection',
  COMMUNITIES_REFERRALS_DATATABLE: 'communities_referrals_datatable',
  COMMUNITIES_REFERRAL_SEARCH: 'communities_referral_search',
  GENERATE_REFERRAL_TEMPLATE: 'generate_referral_template',
  GET_CLIENT_EMAILS: 'get_client_emails',
  GET_EMAIL_DETAILS: 'get_email_details',
  GET_AGENT_SENT_TOURS_FOR_FAMILY: 'get_agent_sent_tours_for_family',
  AGENT_SLUG_FROM_USER: 'agent_slug_from_user',
  COUNTIES_OF_STATE: 'counties_of_state',
  AGENT_COMMUNITY_CONTRACT_BY_USER: 'agent_community_contract_by_user',
  AGENT_COMMUNITY_CONTRACT_BY_SLUG: 'agent_community_contract_by_slug',
  AGENT_COMMUNITY_CONTRACT_BY_ID: 'agent_community_contract_by_id',
  AGENT_COMMUNITY_CONTRACT_BY_COMMUNITY:
    'agent_community_contract_by_community',
  AUTO_CREATE_CONTRACT: 'auto_create_contract',
  FETCH_CLIENT_SIGN_CONTRACT_URL: 'fetch_client_sign_contract_url',
  DATATABLE: 'datatable',
  DATATABLE_RESOURCE: 'datatable_resource',
  UUID_ACTIONS: 'uuid_actions',
  CLIENT_AGENT: 'client_agent'
};
export const QUERY_CACHE_TIME_ONE_HOUR = 60 * 60 * 1000;
export const QUERY_CACHE_TIME_FIFTEEN_MINUTES = 15 * 60 * 1000;
export const FAMILY_STATUS_ACTIVE = 'Active';
export const FAMILY_STATUS_ON_PAUSE = 'On Pause';
export const FAMILY_STATUS_ARCHIVED = 'Archived';
export const FAMILY_STATUS_LONG_TERM = 'Long Term';
export const FAMILY_STATUS_DELETED = 'Deleted';
export const FAMILY_STATUS_TEST = 'Test';
export const FAMILY_STATUS_DUPLICATE = 'Duplicate';
export const FAMILY_STATUS_NOT_ROUTING_READY = 'Not Routing Ready';
export const TYPES_OF_CARE = [
  'Assisted Living',
  'Memory Care',
  'Independent Living',
  'Board and Care Home',
  'Skilled Nursing Facility',
  'Continuing Care Retirement Community(CCRC)',
  'Active Adult Communities (55+)'
];
export enum LogoType {
  DEFAULT = 'default',
  SREN = 'sren'
}

export enum LandingPageType {
  SREN = 'sren',
  D2C = 'd2c'
}

export const CARE_SCOUT_PRICING_PLANS_URL =
  'https://www.carescout.com/care-plans';

export const CARE_SCOUT_PRICING_PLANS_UTM_PARAMS = {
  header:
    'utm_source=seniorly&utm_medium=referral&utm_campaign=2026_01_aw_seniorly_care-plan_nat_all_all&utm_content=banner&utm_term=header',
  footer:
    'utm_source=seniorly&utm_medium=referral&utm_campaign=2026_01_aw_seniorly_care-plan_nat_all_all&utm_content=banner&utm_term=footer',
  tools:
    'utm_source=seniorly&utm_medium=referral&utm_campaign=2026_01_aw_seniorly_care-plan_nat_all_all&utm_content=banner&utm_term=tools-center',
  article:
    'utm_source=seniorly&utm_medium=referral&utm_campaign=2026_01_aw_seniorly_care-plan_nat_all_all&utm_content=banner&utm_term=articles',
  search:
    'utm_source=seniorly&utm_medium=referral&utm_campaign=2026_01_aw_seniorly_care-plan_nat_all_all&utm_content=banner&utm_term=search'
};

export const PrivacyPolicyWaURL =
  'https://www.carescout.com/legal/privacy-policy-wa';

export const TargetBlankLinks = [
  CARE_SCOUT_PRICING_PLANS_URL,
  'https://www.carescout.com/legal/privacy-policy-wa'
];
